var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__C_Badge"},[_c('q-badge',{attrs:{"outline":_vm.outline,"align":_vm.align,"color":_vm.colorNameFormatter(_vm.color)}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }